class RosariumSubscriptions {
  constructor(root) {
    this.root = root;
    this.forms = [...root.querySelectorAll('[data-subscription-checkout]')];
    this.forms.forEach((form) => form.addEventListener('submit', (event) => this.submit(event, form)));
    this.setMinimumDates();
  }

  setMinimumDates() {
    const tomorrow = new Date();
    tomorrow.setHours(12, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minimum = [tomorrow.getFullYear(), String(tomorrow.getMonth() + 1).padStart(2, '0'), String(tomorrow.getDate()).padStart(2, '0')].join('-');
    this.root.querySelectorAll('input[type="date"]').forEach((input) => { input.min = minimum; });
  }

  async submit(event, form) {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-subscription-error]');
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const sellingPlan = Number(data.get('selling_plan'));

    if (!id || !sellingPlan) {
      this.showError(error, this.root.dataset.choiceError || 'Please choose an available arrangement and delivery frequency.');
      return;
    }

    const original = button.textContent;
    button.disabled = true;
    button.textContent = this.root.dataset.preparingLabel || 'Preparing checkout…';
    if (error) error.hidden = true;

    const item = {
      id,
      quantity: 1,
      selling_plan: sellingPlan,
      properties: {
        'Subscription plan': form.dataset.planName || 'Rosarium subscription',
        'Recipient name': String(data.get('recipient_name') || '').trim(),
        'Recipient mobile': String(data.get('recipient_phone') || '').trim(),
        'Preferred start date': String(data.get('start_date') || ''),
        'Delivery note': String(data.get('delivery_note') || '').trim()
      }
    };

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const prefix = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const response = await fetch(`${prefix}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[item]})
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || this.root.dataset.addError || 'This subscription could not be added.');
      }
      window.location.assign(`${prefix}checkout`);
    } catch (problem) {
      this.showError(error, problem.message || this.root.dataset.addError || 'Please try again or contact Rosarium for assistance.');
      button.disabled = false;
      button.textContent = original;
    }
  }

  showError(node, message) {
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
  }
}

const initializeRosariumSubscriptions = (scope = document) => {
  scope.querySelectorAll('[data-subscriptions-root]:not([data-subscriptions-ready])').forEach((root) => {
    root.dataset.subscriptionsReady = 'true';
    new RosariumSubscriptions(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeRosariumSubscriptions());
document.addEventListener('shopify:section:load', (event) => initializeRosariumSubscriptions(event.target));
